import React, { memo } from 'react'
import moment from 'moment'
import { DATE_MOMENT_FORMAT } from 'utils/constants'
import { useSystem } from 'hooks/useSystem'
import styled from 'styled-components'

const StyledScholarshipSources = styled.div`
  font-size: .8rem;
  color: ${({ theme }) => theme.palette.grayscale[3]};
  ul {
    padding-left: 1.5rem;
  }
`

const Divider = styled.div`
  max-width: 15rem;
  border-top: 1px solid ${({ theme }) => theme.palette.grayscale[3]};
  margin: 1rem 0;
`

const ScholarshipSources = (
  {
    divider,
    showLastImportedYMFileDate = true,
    showPublicTaxRecord = true,
    ...props
  }
) => {
  const { lastImportedYMFileDate } = useSystem()
  const widget = (
    <StyledScholarshipSources {...props}>
      <div className="font-weight-bold">Sources:</div>
      <ul>
        <li>NSPA Exchange, last updated {moment().format(DATE_MOMENT_FORMAT)}</li>
        {
          showLastImportedYMFileDate && lastImportedYMFileDate && (
            <li>NSPA Member Profile, last updated {moment(lastImportedYMFileDate).format(DATE_MOMENT_FORMAT)}</li>
          )
        }
        {
          showPublicTaxRecord && (
          <li>Public Tax Records via data from Candid Guidestar, last sourced June 10, 2021</li>
        )}
      </ul>
    </StyledScholarshipSources>
  )
  return divider ? (
    <>
      <Divider />
      {widget}
    </>
  ) : widget
}

export default memo(ScholarshipSources)
